module.exports = __webpack_public_path__ + "557978198f106a3cdd08a42aa886d292.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/brokerage/status.png
// module id = 676
// module chunks = 0